'use client';

import { m } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

export type ProgressBarProps = {
  className?: string;
  color?: string;
  value?: number;
  variant?: 'determinate' | 'indeterminate';
  sx?: Record<string, any>;
};

function ProgressBar({
  className,
  color = 'primary',
  value = 0,
  variant = 'indeterminate',
  sx,
  ...other
}: ProgressBarProps) {
  const colorClasses = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    info: 'bg-info',
    success: 'bg-success',
    warning: 'bg-warning',
    error: 'bg-error',
    inherit: 'bg-current',
  };

  const colorClass = colorClasses[color as keyof typeof colorClasses] || colorClasses.primary;

  return (
    <div
      className={twMerge(
        'w-full h-1 bg-gray-200 dark:bg-gray-700 overflow-hidden relative',
        className
      )}
      {...other}
    >
      {variant === 'determinate' ? (
        <m.div
          className={twMerge(colorClass, 'h-full')}
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
          transition={{
            duration: 0.5,
            ease: [0.43, 0.13, 0.23, 0.96],
          }}
        />
      ) : (
        <>
          <m.div
            className={twMerge(colorClass, 'h-full absolute')}
            initial={{ left: '0%', width: '30%' }}
            animate={{
              left: ['0%', '70%'], // можно регулировать
              width: ['30%', '30%'],
            }}
            transition={{
              duration: 1.5,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse', // ⬅️ туда-обратно
            }}
          />
          <m.div
            className={twMerge(colorClass, 'h-full absolute opacity-30')}
            initial={{ left: '0%', width: '50%' }}
            animate={{
              left: ['0%', '50%'],
              width: ['50%', '50%'],
            }}
            transition={{
              duration: 2.5,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse', // ⬅️ туда-обратно
              delay: 0.5,
            }}
          />
        </>
      )}
    </div>
  );
}

export default ProgressBar;
